var CryptoAgent = "";
export function init() {
  try {
    var eDiv = document.createElement("div");
    if (navigator.appName.indexOf("Internet") >= 0 || navigator.appVersion.indexOf("Trident") >= 0) {
      if (window.navigator.platform == "win32" || window.navigator.cpuClass == "x86" || window.navigator.cpuClass == "arm") {
          eDiv.innerHTML = "<object id=\"CryptoAgent\" codebase=\"CryptoKit.XDJK.x86.cab\" classid=\"clsid:ADDE0F49-8B7A-4F29-8C63-BAC472A91663\" ></object>";
      }
      else {
          eDiv.innerHTML = "<object id=\"CryptoAgent\" codebase=\"CryptoKit.XDJK.x64.cab\" classid=\"clsid:01C518F6-F883-41F8-85C8-A7F9031DDB4B\" ></object>";
      }
    }else {
      console.log("浏览器不支持插件");
      // eDiv.innerHTML = "<embed id=\"CryptoAgent\" type=\"application/npCryptoKit.Ultimate.x86\" style=\"height: 0px; width: 0px\">";
    }
    document.body.appendChild(eDiv);
    CryptoAgent = document.getElementById("CryptoAgent");
    var bResult = CryptoAgent.SetSM2CSPList('CFCA FOR UKEY CSP v1.1.0');
    SelectCertificateOnClick()
  }
  catch (e) {
    console.log(e);
    return;
  }
  
}


// 获取证书信息
export function SelectCertificateOnClick() {
  try {
      var subjectDNFilter = "";
      var issuerDNFilter = "";
      var serialNumFilter = "";
      var bSelectCertResult = "";
      // subjectDNFilter = document.getElementById("SubjectDNFilter").value;
      // issuerDNFilter = document.getElementById("IssuerDNFilter").value;
      // serialNumFilter = document.getElementById("SerialNumFilter").value;

      bSelectCertResult = CryptoAgent.SelectCertificate(subjectDNFilter, issuerDNFilter, serialNumFilter);                        
      if (!bSelectCertResult) {
        var errorDesc = CryptoAgent.GetLastErrorDesc();
        console.log(errorDesc);
        return;
      }
      return bSelectCertResult
      // document.getElementById("SelectCertDN").value = SubjectDN;
  }
  catch (e) {
    try {
      var errorDesc = CryptoAgent.GetLastErrorDesc();
      return false
    } catch (error) {
      return false
    }
  }
}

function GetSelectedItemIndex(itemName = '1') {
  // var ele = document.getElementsByName(itemName);
  // SM2加密类型: 1 现国密标准  2 原国密标准(C1||C2||C3)

  var ele = ['1', '2']
  for (var i = 0; i < ele.length; i++) {
    if (ele[i] == itemName) {
      return i;
    }
  }
}

/**
 * <input type="radio" name="SignType" value="Attach" checked="checked" />PKCS#7带原文签名
 * <input type="radio" name="SignType" value="Detach" />PKCS#7不带原文签名
 * <input type="radio" name="SignType" value="PKCS#1" />PKCS#1签名
 * <input type="radio" name="algorithm" checked="checked" value="SHA-1" />SHA-1
 * <input type="radio" name="algorithm" value="SHA-256" />SHA-256  
 * 
 * 证书类型：       
 * <input type="radio" name="certtype" checked="checked" value="SM2"/>SM2
 * <input type="radio" name="certtype" value="RSA"/>RSA
 */
function GetSelectedItemValue(itemName) {
  // var ele = document.getElementsByName(itemName);
  let ele = ['Attach', 'Detach', 'PKCS#1', 'SHA-1', 'SHA-256', 'SM2', 'RSA']
  for (var i = 0; i < ele.length; i++) {
    
    if (ele[i] == itemName) {
      return ele[i];
    }
  }
}


/**
 * 
 * 签名
 * @param {*签名原文} SourceData 签名原文
 * @param {*哈希算法(仅对RSA算法有效，SM2默认使用SM3哈希算法)} algorithm
 * @param {*签名类型} SignTypes
 * 
 * 以下参数是使用指定的软证书签名
 * @param {*证书类型:SM2 RSA} certtype 
 * @param {*用于签名的软证书路径} signcertfilepath 
 * @param {*用于签名的软证书密码} signcertfilepassword
 * @returns {
 * isSuccessful: false   是否签名成功
 * result: SourceData    签名结果
 * message: errorDesc    报文
 * }
 */
export function SignOnClick(SourceData, algorithm = 'SHA-1', SignTypes = 'Attach', certtype = 'SM2', signcertfilepath = '', signcertfilepassword = '') {
  try {
		
    var selectedIndex = 0;   
    // 1 从windows证书库中选择签名证书 2使用指定的软证书签名
    selectedIndex = GetSelectedItemIndex("1")
    
    if (selectedIndex == 0) {
      var source = ""; // 签名原文
      var signature = ""; // 签名结果
      var signType = "";
      var selectedAlg = GetSelectedItemValue(algorithm);
      // source
      source = SourceData;
      
      // sign type
      // certificate information identifier
      signType = GetSelectedItemValue(SignTypes);
      
      if ("Attach" == signType) {
        // PKCS#7 Attach
        signature = CryptoAgent.SignMsgPKCS7(source, selectedAlg, true);
      }
      else if ("Detach" == signType) {
        // PKCS#7 Detach
        signature = CryptoAgent.SignMsgPKCS7(source, selectedAlg, false);                 
      }
      else {
        // PKCS#1
        signature = CryptoAgent.SignMsgPKCS1(source, selectedAlg);
      }
      if (!signature) {
          var errorDesc = CryptoAgent.GetLastErrorDesc();
          console.log(errorDesc);
          return {
            isSuccessful: false,
            result: SourceData,
            message: errorDesc
          };
      }
      return {
        isSuccessful: true,
        result: signature,
        message: '成功'
      };
    } else {
      var filename = "";
      var password = "";
      var source = "";
      var signature = ""; // // 签名结果                 
      
      var signType = "";
      var selectedAlg = GetSelectedItemValue(algorithm);
      var certificatetype = GetSelectedItemValue(certtype);

      // document.getElementById("Signature").value = "";                  

      //file password source
      if (signcertfilepath.length > 0) {
        filename = signcertfilepath;
      }
      if (signcertfilepassword.length > 0) {
        password = signcertfilepassword;
      }
      source = SourceData;
      // sign type
      // certificate information identifier
      signType = GetSelectedItemValue(SignTypes);
      if ("Attach" == signType) {
        // PKCS#7 Attach
        signature = CryptoAgent.SignMsgPKCS7_BySoftCert(filename, password, certificatetype, source, selectedAlg, true);
      }
      else if ("Detach" == signType) {
        // PKCS#7 Detach
        signature = CryptoAgent.SignMsgPKCS7_BySoftCert(filename, password, certificatetype, source, selectedAlg, false);
      }
      else {
        // PKCS#1
        signature = CryptoAgent.SignMsgPKCS1_BySoftCert(filename, password, certificatetype, source, selectedAlg);
      }
      // Opera浏览器，NPAPI函数执行结果为false时，不能触发异常，需要自己判断返回值。
      if (!signature) {
          var errorDesc = CryptoAgent.GetLastErrorDesc();
          console.log(errorDesc);
          return {
            isSuccessful: false,
            result: SourceData,
            message: errorDesc
          };
      }
      return {
        isSuccessful: true,
        result: signature,
        message: '成功'
      };
    }
  }
  catch (e) {
    try {
      var errorDesc = CryptoAgent.GetLastErrorDesc();
      console.log(e);
      return {
        isSuccessful: false,
        result: SourceData,
        message: errorDesc
      }
    } catch (error) {
      return {
        isSuccessful: false,
        result: SourceData,
        message: errorDesc
      };
    }
  }
}


/**
 * 
 * 验签
 * @param {*签名原文} signaData 签名原文
 * @param {*验签算法 SM2  RSA} signalgorithm
 * @param {**哈希算法(仅对RSA算法有效，SM2默认使用SM3哈希算法)} algorithm
 */
// export function  VerifyPKCS1OnClick(signaData, signalgorithm = 'SM2', algorithm = 'SHA-1') {
//   try {
//       var signatureAlg = "";
//       var bWithZValue = true;
//       var signature = "";
//       var source = "";
//       var base64cert = "";
//       var bResult = false;
//       var hashAlg = "";

//       signatureAlg = GetSelectedItemValue(VerifyPKCS1OnClick);
//       hashAlg = GetSelectedItemValue(algorithm);            

//       signature = signaData;
//       source = document.getElementById("SourceData").value;
//       base64cert = document.getElementById("Base64Cert").value;
//       bResult = CryptoAgent.VerifyMsgSignaturePKCS1(signature, signatureAlg, source, hashAlg, base64cert);
//       if (!bResult) {
//           var errorDesc = CryptoAgent.GetLastErrorDesc();
//           alert(errorDesc);
//           bResult = false;
//       }
//       alert("验签结果：" + bResult);
              
//   } catch (e) {
//       var errorDesc = CryptoAgent.GetLastErrorDesc();
//       alert(errorDesc);
//   }
// }